import type { CardFinish } from "@/lib/api";

/**
 * Per-finish glow color — Draw-UI-only display meta that pairs with
 * CARD_FINISHES.accentText (lib/cards.ts). Alpha rises with rarity so the
 * tier picker / reveal glow scales from restrained (base) to loud (gold vinyl).
 * Hues follow the R-25 등급명 재라벨(lib/cards.ts): blue_ice=Green Emerald(에메랄드),
 * gold_ice=Blue Sapphire(스카이), red_ice=Crimson Ruby(로즈) — finish id는 백엔드 키.
 */
const FINISH_GLOW: Record<CardFinish, string> = {
  base: "rgba(255, 255, 255, 0.22)",
  holo: "rgba(196, 181, 253, 0.38)",
  blue_ice_sapphire: "rgba(110, 231, 183, 0.45)",
  gold_ice_sapphire: "rgba(125, 211, 252, 0.5)",
  red_ice_sapphire: "rgba(253, 164, 175, 0.55)",
  black_ice_prizms: "rgba(240, 171, 252, 0.6)",
  padparadscha_sapphire: "rgba(253, 186, 116, 0.65)",
  gold_vinyl: "rgba(253, 224, 71, 0.7)",
};

export function finishGlow(finish: string): string {
  return FINISH_GLOW[finish as CardFinish] ?? FINISH_GLOW.base;
}
